import { object, mixed, string } from 'yup'

export const slabDistributionSchema = object({
  element_guid: string().default(''),
  distribution_x: mixed().oneOf(['RigidForce', 'SingleSpan', 'WallLength']).default('SingleSpan'),
  distribution_y: mixed().oneOf(['RigidForce', 'SingleSpan', 'WallLength']).default('SingleSpan'),
})
